module.exports = __webpack_public_path__ + "img/ring_r_0_null_null@2x.778c0b3c.png";